import React from 'react'
import { ActionButtons } from '../../dashboard/subContent/buttonsContainer/ActionButtons'
import { SearchContainer } from '../../dashboard/subContent/searchContainer/SearchContainer'
import { UsuariosDataTable } from '../../dashboard/subContent/dataTable/UsuariosDataTable'
import { mockUsuarios } from '../../../assets/UsuariosMocks'
import { InputCheckBox } from '../../dashboard/subContent/CheckBox/InputCheckBox'
import { MemberService } from '../../../services/MemberService'
import { useEffect, useState } from 'react'
import logger from '../../../utils/logger'
import { object } from 'framer-motion/client'
import useSearchMember from '../../../hooks/fetchUsers'
import { MemberStatesMapping } from './MemberStateModel'
import { ModalLoadingComponent } from '../../common/LoadingComponent/ModalLoadingComponent'
import { UseVisibleLoadingModal } from '../../../hooks/DataTable-hooks/UseVisibleLoadingModal'
import { memberSearchEschema } from './memberSearchSchema'
import { useSelector } from 'react-redux'
import { actionsPack } from './ActionsOnUserMock'


export const MemberManagement = () => {

  const URL = 'Member'
  const { enableModal } = UseVisibleLoadingModal()
  const { renderUsers, handleObject, loading, customData } = useSearchMember(URL)

  const list = useSelector((data) => data.commonData.lista.formationPlaces)

  useEffect(() => {
    document.title = 'TPA® Admin - Miembros'
  }, [])

  const [HideReached, setHideReached] = useState(true)

  const HideReachedValue = (params) => {
    setHideReached(params)
  };

  const [defaultCheckBoxPageSize, setDefaultCheckBoxPageSize] = useState(null)

  const onInputCheckBoxPageSize = (PageSize) => {
    setDefaultCheckBoxPageSize(PageSize)
  };

  return (
    <>

      <>

        <div className='m-4'>

          <div className='formation-card-header'>
            <div className='formation-container-actions card-tools'>

              <div className="title-decoration">
                <div class="accent-line"></div>
                <h1 className='pull-left formation-page-title mb-0'>Gestión de Miembros</h1>
              </div>


            </div>
          </div>
        </div>



        <ActionButtons
          dropdown={true}
          usersData={renderUsers}
          handleObject={handleObject}
        />


        <SearchContainer
          handleObject={handleObject}
          searchSchema={memberSearchEschema}
          selectListOptions={list}
          defaultParam={'FormationPlaceId'}
          paramDfValue={'0'}
        />
        <InputCheckBox
          handleObject={handleObject}
          HideReachedValue={HideReachedValue}
          defaultPageSize={defaultCheckBoxPageSize}
        />

        <UsuariosDataTable
          actionsPack={actionsPack}
          stateModel={MemberStatesMapping}
          currentPagination={customData.current}
          usersData={renderUsers}
          handleObject={handleObject}
          loading={loading}
          memberShip={true} //👉 activa el modal de informacion del miembro
          alert={true} //👉 activa el modal de alerta de acciones 
          enableMobileLoading={enableModal}
          HideReached={HideReached}
          onInputCheckBoxPageSize={onInputCheckBoxPageSize}
        // onFilter={handleObject}
        />
      </>




    </>
  )
}
